import { Component, Inject, OnInit } from "@angular/core";
import { MatBottomSheetRef, MAT_BOTTOM_SHEET_DATA } from "@angular/material";
import { AddressModalResult } from "../../shared/contentTypes";
import { AddressCompareVM } from "../../components/orderAddressQuery/orderAddressQuery.service";

export interface AddressVerificationDialogModalData {
  /** Titel (langkey placeholder) */
  title: string;
  /** Content (raw text / html, NOT a langkey) */
  //content: string;
  compare: AddressCompareVM;
  /** FirstButton Label (langkey placeholder) */
  firstBtnLabel: string;
  /** SecondButton Label (langkey placeholder) */
  secondBtnLabel: string;
  /** ThirdButton Label (langkey placeholder) optional */
  thirdBtnLabel?: string;
}

@Component({
  selector: "app-addressdialog",
  templateUrl: "./addressVerificationDialog.component.html",
  styleUrls: ["./addressVerificationDialog.component.scss"]
})
export class AddressVerificationDialogComponent implements OnInit {

  constructor(public bottomSheetRef: MatBottomSheetRef<AddressVerificationDialogComponent, AddressModalResult>
    , @Inject(MAT_BOTTOM_SHEET_DATA) public addressVerificationData: AddressVerificationDialogModalData) {
  }

  ngOnInit() {
  }

  /** return AnounceModalResult.FirstButton to define first buttom event */
  public firstBtnClick() {
    const me = this;
    me.bottomSheetRef.dismiss(AddressModalResult.FirstButton);
  }

  /** return AnounceModalResult.SecondButton to define second buttom event */
  public secondBtnClick() {
    const me = this;
    me.bottomSheetRef.dismiss(AddressModalResult.SecondButton);
  }

  public thirdBtnClick() {
    const me = this;
    me.bottomSheetRef.dismiss(AddressModalResult.ThirdButton);
  }
}
